import { gql } from "@apollo/client";

export const GET_AGENDAITEMS_BY_ASSEMBLYID = gql`
    query GetAgendaitemsByAssemblyId($assemblyid: uuid!) {
        agendaitem_parents: cond_agendaitems(
            where: { assemblyid: { _eq: $assemblyid }, parentagendaitemid: { _is_null: true } }
            order_by: { sort: asc }
        ) {
            id
            sort
            agendaitems_mls {
                language
                id
                text
                description
                internalcomments
                protocoltext
            }
            agendaitemfiles: v_agendaitemfiles(distinct_on: id) {
                id
                fileid
                mimetype
                name
                filedate
            }
            votingagendaitemsCounter: votingagendaitems_aggregate {
                aggregate {
                    count
                }
            }
            agendaitem_children: agendaitems {
                id
                sort
                parentagendaitemid
                agendaitems_mls {
                    language
                    id
                    text
                    description
                    internalcomments
                    protocoltext
                }
                agendaitemfiles: v_agendaitemfiles(distinct_on: id) {
                    id
                    fileid
                    mimetype
                    name
                    filedate
                }
                votingagendaitemsCounter: votingagendaitems_aggregate {
                    aggregate {
                        count
                    }
                }
            }
        }
    }
`;

export const GET_AGENDAFILES_BY_ASSEMBLYID = gql`
    query GetAgendaFilesByAssemblyId($assemblyid: uuid) {
        assemblyfiles: file_v_assemblyfiles(
            where: {
                assemblyid: { _eq: $assemblyid }
                _and: { type: { _in: [313, 314] }, _and: { state: { _nin: [0, 5] } } }
            }
            order_by: { name: asc }
        ) {
            fileid
            type
            id
            extension
            filedate
            name
            mimetype
        }
    }
`;

export const GET_ASSEMBLYFILES_FOR_COOWNER_BY_ASSEMBLYID = gql`
    query GetAssemblyFilesForCoownerByAssemblyId($assemblyid: uuid) {
        assemblyfiles: file_v_assemblyfiles(
            where: {
                assemblyid: { _eq: $assemblyid }
                _or: [{ type: { _eq: 313 }, state: { _in: [6, 9] } }, { type: { _eq: 314 }, state: { _nin: [0, 5] } }]
            }
            order_by: { name: asc }
        ) {
            fileid
            type
            id
            extension
            filedate
            name
            mimetype
        }
    }
`;

export const UPSERT_AGENDAITEMS = gql`
    mutation UpsertAgendaItems($objects: [cond_agendaitems_insert_input!]!) {
        insert_cond_agendaitems(
            objects: $objects
            on_conflict: { constraint: PK_agendaitems, update_columns: [sort] }
        ) {
            returning {
                id
                assemblyid
                agendaitems_mls {
                    text
                    id
                    description
                    internalcomments
                    protocoltext
                }
            }
        }
    }
`;

export const UPSERT_AGENDAITEM_PROTOCOLTEXT = gql`
    mutation UpsertAgendaItemProtocoltext($agendaitemId: uuid!, $protocoltext: String!) {
        update_cond_agendaitems_mls(
            _set: { protocoltext: $protocoltext }
            where: { agendaitemid: { _eq: $agendaitemId } }
        ) {
            affected_rows
        }
    }
`;

export const DELETE_AGENDAITEM = gql`
    mutation DeleteAgendaItem($agendaitemId: uuid!) {
        delete_cond_agendaitems(where: { id: { _eq: $agendaitemId } }) {
            affected_rows
        }
    }
`;

export const DELETE_ALL_AGENDAITEMS_BY_ASSEMBLYID = gql`
    mutation DeleteAllAgendaItemsByAssemblyId($assemblyId: uuid!) {
        delete_cond_agendaitems(where: { assemblyid: { _eq: $assemblyId } }) {
            affected_rows
        }
    }
`;

export const GET_AGENDAITEM_TEMPLATES = gql`
    query GetAgendaitemsTemplates {
        agendaitem_parents: cond_agendaitemtemplates(
            where: { parentagendaitemtemplateid: { _is_null: true } }
            order_by: { sort: asc }
        ) {
            id
            sort
            agendaitemtemplates_mls {
                language
                id
                text
                description
            }
            agendaitem_children: subagendaitemtemplates {
                id
                sort
                parentagendaitemtemplateid
                agendaitemtemplates_mls {
                    language
                    id
                    text
                    description
                }
            }
        }
    }
`;

export const DELETE_AGENDAITEM_TEMPLATES = gql`
    mutation DeleteAgendaItemTemplates($agendaitemIds: [uuid!]) {
        delete_cond_agendaitemtemplates(where: { id: { _in: $agendaitemIds } }) {
            affected_rows
        }
    }
`;

export const UPSERT_AGENDAITEMS_TEMPLATES = gql`
    mutation UpsertAgendaItemsTemplates($objects: [cond_agendaitemtemplates_insert_input!]!, $agendaitemIds: [uuid!]) {
        delete_cond_agendaitemtemplates(where: { id: { _in: $agendaitemIds } }) {
            affected_rows
        }

        insert_cond_agendaitemtemplates(
            objects: $objects
            on_conflict: { constraint: PK_agendaitemtemplates, update_columns: [sort] }
        ) {
            returning {
                id
                agendaitemtemplates_mls {
                    text
                    id
                    description
                }
            }
        }
    }
`;
